import React from "react";

function FooterHours() {
  const year = new Date().getFullYear();
  return (
    <div className="flex flex-col gap-16 max-sm:gap-6">
      <div>
        <h6 className="h6-literata max-sm:text-base mq735:text-lg">
          Öppettider
        </h6>
        <div className="flex gap-7 pt-4">
          <p className="body-jost-small">Måndag - Fredag :</p>
          <p className="body-jost-small">10:00 - 18:00</p>
        </div>
      </div>
      <div className="flex justify-start  text-sm font-jost text-gray">
        <p>
          Copyright &copy; {year} Oscarsrestaurang
          <br />
          <a
            href="https://luday.se"
            // className="hover:underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i>Designed by</i> <span className="text-red">Luday AB</span>
          </a>
        </p>
      </div>
      {/* <h1 className="flex justify-end body-jost-small">
        Copyright {year} Oscarsrestaurang <br></br> <a href="https://luday.se"> <i> Designed by</i> <span className="text-red">Luday AB</span></a>
      </h1> */}
    </div>
  );
}

export default FooterHours;
